export default __webpack_public_path__ + "static/favicon-1468037070a2d5dfe7053e1ee4536931.ico";